export default "__VITE_ASSET__BCRaJYaK__"